import $ from 'jquery'
import gsap from 'gsap'
import { v4 as uuid } from 'uuid'

const TYPE_SLIDER_CLASS = 'moodpoll__step--range'

const STEP_SELECTOR = '.moodpoll__step'
const SUCCESS_SELECTOR = '.moodpoll__step.moodpoll__step--success'
const RESULTS_SELECTOR = '.moodpoll__result-items'
const SLIDER_ACTION_SELECTOR = '.moodpoll__range-action .btn'
const LOADER_SELECTOR = '.moodpoll__results-loader'

$('.moodpoll__result-item').remove()
class MoodPolls {
  constructor(selector = '.moodpoll') {
    this.polls = $(selector)

    this.init()
  }

  init() {
    this.polls.each((index, poll) => {
      new MoodPoll(poll)
    })
  }
}
class MoodPoll {
  constructor(el) {
    this.el = $(el)

    this.elements = {
      steps: $(STEP_SELECTOR, el),
      success: $(SUCCESS_SELECTOR, el),
      results: $(RESULTS_SELECTOR, el),
      resultItems: null,
      loader: $(LOADER_SELECTOR, el),
      currentStep: $($(STEP_SELECTOR, el).get(0)),
    }

    this.settings = {
      id: parseInt(this.el.data('moodpoll-id')),
      showResults: Boolean(parseInt(this.el.data('moodpoll-show-results'))),
      voteUri: this.el.data('moodpoll-vote-uri'),
      resultsUri: this.el.data('moodpoll-results-uri'),
    }

    this.pollData = []
    this.currentStepIndex = 0
    this.isAlreadyVoted = this.getAlreadyVotedState()

    this.init()
  }

  init() {
    // If user has already voted we directly show the success
    if (this.isAlreadyVoted) {
      return this.showSuccess()
    }
    // Initialize the steps (questions) with child classes
    this.initSteps()
    // Listen to events from child steps
    this.listen()
  }

  initSteps() {
    // init the steps itself, except the success step
    this.elements.steps.not(this.elements.success).each((index, step) => {
      // init slider step
      if ($(step).hasClass(TYPE_SLIDER_CLASS)) {
        return new SliderStep(step)
      }
      // init a button step
      new ButtonStep(step)
    })
  }

  listen() {
    // listen for steps to trigger the answer with data
    this.el.on('moodpoll-answered', this.onAnswered.bind(this))
  }

  onAnswered(event, answerId) {
    // prevent bubbling up
    event.stopImmediatePropagation()
    // set the data
    this.pollData.push(answerId)
    // proceed to the next step
    this.nextStep()
  }

  nextStep() {
    // If we are on the last step (success) we want to also save the votes and get results
    if (this.currentStepIndex + 1 === this.elements.steps.length - 1) {
      return this.showSuccess()
    }

    this.showStep(this.currentStepIndex + 1)
  }

  showSuccess() {
    // Send poll data to server
    this.vote()
    // Activate last step (success)
    this.showStep(this.elements.steps.length - 1)
    // Check if we really need the results
    if (!this.settings.showResults) {
      this.removeResults()
      return
    }
    // Load the results partial from server
    this.loadResults()
  }

  showStep(index) {
    const nextStep = $(this.elements.steps.get(index))
    this.animateStep(this.elements.currentStep, nextStep)

    // Update values
    this.elements.currentStep = nextStep
    this.currentStepIndex = index
  }

  animateResultLoader() {
    this.elements.loader.css('position', 'absolute')
    gsap.to(this.elements.loader, {
      y: 5,
      opacity: 0,
      duration: 0.5,
    })
  }

  animateResults(results) {
    const oldHeight = this.elements.results.height()

    this.elements.results.empty().append(results)
    this.elements.resultItems = $('.moodpoll__result-item', this.el)

    this.animateResultLoader()
    gsap.fromTo(
      this.elements.results,
      {
        height: oldHeight,
      },
      {
        height: this.elements.results.height(),
        duration: 0.2,
      }
    )
    const gtl = gsap.timeline()

    gtl.to(this.elements.resultItems, {
      opacity: 1,
      duration: 0.3,
    })

    this.elements.resultItems.each((index, item) => {
      const number = $('.moodpoll__result-label-value', item)
      const bar = $('.moodpoll__result-bar-value', item)
      const width = bar.width()

      const tl = gsap.timeline()

      tl.fromTo(
        bar,
        { width: 0 },
        {
          width: width,
          duration: 0.4,
        }
      )

      tl.from(number, {
        y: 5,
        opacity: 0,
        duration: 0.2,
      })

      gtl.add(tl)
    })
  }

  animateStep(oldStep, newStep) {
    // generate preconditions nessecary to transition to next step
    newStep.css('display', 'block')
    oldStep.css('position', 'absolute')
    // animate container height
    gsap.fromTo(
      this.el,
      {
        height: oldStep.outerHeight(),
      },
      {
        height: newStep.outerHeight(),
        duration: 0.2,
        onComplete: () => {
          // reset container height
          this.el.css('height', '')
        },
      }
    )
    // hide old step
    gsap.to(oldStep, {
      y: 5,
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        // set final values of the old step
        oldStep.css('display', 'none')
        oldStep.css('position', '')
      },
    })
    // show new step
    gsap.to(newStep, {
      y: 0,
      opacity: 1,
      duration: 0.2,
    })
  }

  vote() {
    const uid = this.getUserSignature()

    this.pollData.forEach(answer => {
      const params = {
        tx_nlmoodpolls_pi1: {
          userAnswer: {
            answer,
            userSignature: uid,
          },
        },
      }

      $.ajax({
        url: this.settings.voteUri,
        data: params,
        cache: false,
        contentType: 'application/x-www-form-urlencoded',
        type: 'POST',
      })
    })

    this.setAlreadyVotedState()
  }

  loadResults() {
    $.get(this.settings.resultsUri, result => {
      this.animateResults(result)
    })
    // * Keep this for dev purpose
    // setTimeout (()=> {
    //   this.animateResults(`
    //   <div class="moodpoll__result-item-question">
    //       Lorem ipsum dolor sit amet, consetetur sadipscing?
    //     </div>
    //     <div class="moodpoll__result-item">
    //         <div class="moodpoll__result-label">
    //             <div class="moodpoll__result-label-text">One</div>
    //             <div class="moodpoll__result-label-value">52%</div>
    //         </div>
    //         <div class="moodpoll__result-bar">
    //             <div class="moodpoll__result-bar-value" style="width: 52%;"></div>
    //         </div>
    //     </div>
    //     `)
    // }, 1000)
  }

  getAlreadyVotedState() {
    return Boolean(localStorage.getItem('moodpoll-voted-' + this.settings.id))
  }

  setAlreadyVotedState() {
    localStorage.setItem('moodpoll-voted-' + this.settings.id, '1')
  }

  getUserSignature() {
    const signature = localStorage.getItem('moodpoll-user-signature')

    if (!signature) {
      this.createUserSignature()
    }

    return localStorage.getItem('moodpoll-user-signature')
  }

  createUserSignature() {
    localStorage.setItem('moodpoll-user-signature', uuid())
  }

  removeResults() {
    this.elements.results.parent().remove()
  }
}

class Step {
  constructor(el) {
    this.el = $(el)
    this.answers = $('[data-moodpoll-answer-id]', el)

    this.value = null
  }

  propagateAnswer() {
    this.el.trigger('moodpoll-answered', [this.value])
  }
}

class ButtonStep extends Step {
  constructor(el) {
    super(el)

    this.listen()
  }

  listen() {
    this.answers.on('click', this.onAnswerClick.bind(this))
  }

  onAnswerClick(event) {
    this.value = $(event.currentTarget).data('moodpoll-answer-id')
    this.propagateAnswer()
  }
}

class SliderStep extends Step {
  constructor(el) {
    super(el)

    this.slider = $('input', el)
    this.nextTrigger = $(SLIDER_ACTION_SELECTOR, el)

    this.range = this.slider.get(0).max / (this.answers.length - 1)
    this.index = Math.round(this.slider.get(0).value / this.range)

    this.init()
  }

  init() {
    this.setValueByCurrentIndex()
    this.listen()
  }

  listen() {
    this.slider.on('input change', this.onSliderChange.bind(this))
    this.nextTrigger.on('click', this.onNextTriggerClick.bind(this))
  }

  onSliderChange(event) {
    const index = Math.round(event.target.value / this.range)

    // on slider relase
    // TODO: Check IE 11 for change and input event
    if (event.type === 'change') {
      this.animateRangeValue()
    }

    // check index chnaged
    if (index !== this.index) {
      this.animateAnswerChange(index)
      this.index = index
      this.setValueByCurrentIndex()
    }
  }

  onNextTriggerClick() {
    this.propagateAnswer()
  }

  setValueByCurrentIndex() {
    const answer = this.answers.get(this.index)
    this.value = $(answer).data('moodpoll-answer-id')
  }

  animateRangeValue() {
    const props = { value: this.slider.get(0).value }
    gsap.to(props, {
      value: this.index * this.range,
      duration: 0.2,
      onUpdate: () => {
        this.slider.get(0).value = props.value
      },
    })
  }

  animateAnswerChange(index) {
    const oldAnswer = this.answers.get(this.index)
    const newAnswer = this.answers.get(index)

    gsap.to(oldAnswer, {
      opacity: 0,
      duration: 0.4,
    })

    gsap.to(newAnswer, {
      opacity: 1,
      duration: 0.4,
    })
  }
}

export default MoodPolls
